import { RegionId } from "../generated/enums"

export function isRegionInNvz(region: RegionId) {
    return region === RegionId.Wales
}
